export default __webpack_public_path__ + "static/media/cake2.dd3a1f53.jpg";